import { EntityTypes } from './enums/entityTypes';

export interface SupplierActivity {
  activityId: string;
  orgId: string;
  supplierName: string;
  activityDescription: string;
  activityDate: number;
  entityType: EntityTypes.supplierActivity;
  created: number;
  lastUpdated: number;
}
